import { render } from "./NoticiasComp.vue?vue&type=template&id=0476c761"
import script from "./NoticiasComp.vue?vue&type=script&lang=js"
export * from "./NoticiasComp.vue?vue&type=script&lang=js"

import "./NoticiasComp.vue?vue&type=style&index=0&id=0476c761&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__